import React from 'react';
import {BrowserRouter as Router,Route} from 'react-router-dom';


import { Main } from './components/main'

import './styles/header.css'



class App extends React.Component {

    constructor(props){
      super(props);
    }

    componentDidMount() {
    }

  render() {
    return (
    <div id="b">
        <ul id="h" className="menu-list">
            <li className="selected"><a href="/">Beer Central</a></li>
        </ul>
      <Router>
        <div>
          <Route exact path="/" component={Main} />
        </div>
      </Router>
    </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js